import { IMatchRunChain } from '@nkr/models/index';

export interface IChainDisplay {
    swapIndex: number,
    chainIndex: number,
    chainStart: number,
    chain: IMatchRunChain,
    isExpanded: boolean,
    isSelected: boolean,
    isDeleted: boolean,
    rank: number
}